import { render, staticRenderFns } from "./APAutoMsg.vue?vue&type=template&id=c10fff02&scoped=true&"
import script from "./APAutoMsg.vue?vue&type=script&lang=js&"
export * from "./APAutoMsg.vue?vue&type=script&lang=js&"
import style0 from "./APAutoMsg.vue?vue&type=style&index=0&id=c10fff02&lang=less&scoped=true&"
import style1 from "./APAutoMsg.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10fff02",
  null
  
)

component.options.__file = "APAutoMsg.vue"
export default component.exports